import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import SideNav from "./SideNav";
import TopNav from "./TopNav";
import { navConfig } from "./config/navConfig";
import { useTheme, useMediaQuery } from "@mui/material";

const drawerWidth = 240;

function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    const storedUser = localStorage.getItem("authUser");
    const storedRole = localStorage.getItem("userRole");

    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setLoggedInUser({ ...parsedUser, role: storedRole });
    }
  }, []);

  const navLinks = loggedInUser?.role ? navConfig[loggedInUser.role] || [] : [];

  return (
    <div className="app-container flex h-screen">
      <SideNav
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        navLinks={navLinks}
        user={loggedInUser}
      />

      <div
        className="flex flex-col w-full"
        style={{
          marginLeft: isDesktop ? drawerWidth : 0,
          transition: "margin 0.3s ease",
        }}
      >
        <TopNav
          onMenuClick={() => setIsSidebarOpen(true)}
          user={loggedInUser}
        />

        <div className="flex-1 overflow-auto" style={{ backgroundColor: "#F7F8FC" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;
